"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslatableError = void 0;
const sdk_common_1 = require("@sisense/sdk-common");
const initialize_i18n_js_1 = require("./initialize-i18n.js");
const index_js_1 = require("./resources/index.js");
class TranslatableError extends sdk_common_1.AbstractTranslatableError {
    constructor(translationKey, interpolationOptions) {
        super(index_js_1.PACKAGE_NAMESPACE, {
            key: translationKey,
            interpolationOptions: interpolationOptions,
        }, initialize_i18n_js_1.i18nextInstance.t);
    }
}
exports.TranslatableError = TranslatableError;
